<template>
  <div class="case-logic-toolbar" :class="{[state.toolbarPosition]: true}">
    <div class="buttons">
      <md-button
        v-if="!readonly"
        class="md-icon-button"
        :class="{ 'md-primary': isToolActive('pointer') }"
        @click="setActiveTool('pointer')"
      >
        <md-icon>mouse</md-icon>
      </md-button>
      <md-button
        class="md-icon-button"
        :class="{
          'md-primary': isToolActive('grab'),
        }"
        @click="setActiveTool('grab')"
      >
        <md-icon>pan_tool</md-icon>
        <md-tooltip>Space</md-tooltip>
      </md-button>
      <md-button
        v-if="!readonly"
        class="md-icon-button"
        :class="{ 'md-primary': isToolActive('lasso') }"
        @click="setActiveTool('lasso')"
      >
        <md-icon>highlight_alt</md-icon>
      </md-button>
      <md-button v-if="!readonly" class="md-icon-button" @click="addGroup">
        <img class="icon" src="../assets/icons/group-nodes.svg">
      </md-button>
      <div v-if="!readonly" class="divider" />
      <md-button v-if="!readonly" class="md-icon-button" @click="undo">
        <md-icon>undo</md-icon>
      </md-button>
      <md-button v-if="!readonly" class="md-icon-button" @click="redo">
        <md-icon>redo</md-icon>
      </md-button>
      <div class="divider" />
      <md-button class="md-icon-button" @click="cycleToolbarPosition">
        <md-icon>grid_view</md-icon>
      </md-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'case-logic-toolbar',
  props: {
    activeTool: {
      type: String,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
    getPreference: {
      type: Function,
      required: true,
    }
  },
  data() {
    return {
      state: {
        toolbarPosition: this.getPreference('toolbarPosition') || 'topRight'
      }
    }
  },
  methods: {
    isToolActive(tool) {
      return this.activeTool === tool;
    },
    setActiveTool(tool) {
      this.$emit('setActiveTool', tool);
    },
    addGroup() {
      this.$emit('addGroup');
    },
    undo() {
      this.$emit('undo');
    },
    redo() {
      this.$emit('redo');
    },
    cycleToolbarPosition() {
      const toolbarPositions = ['topRight', 'topLeft', 'bottomLeft', 'bottomRight'];
      const nextToolbarPosition = toolbarPositions[toolbarPositions.indexOf(this.state.toolbarPosition) + 1] || toolbarPositions[0];
      this.state.toolbarPosition = nextToolbarPosition;
      this.$emit('setPreference', 'toolbarPosition', this.state.toolbarPosition);
    },
  },
};
</script>

<style scoped>
.case-logic-toolbar {
  position: absolute;
  z-index: 1002;
}

.case-logic-toolbar.topLeft {
  top: 0;
  left: 0;
}

.case-logic-toolbar.topRight {
  top: 0;
  right: 0;
}

.case-logic-toolbar.bottomLeft {
  bottom: 0;
  left: 0;
}

.case-logic-toolbar.bottomRight {
  /* The zoom controls are currently on the bottom right
  of the editor */
  bottom: 32px;
  right: 0;
}

.case-logic-toolbar .buttons {
  display: flex;
  padding: 0 6px;
  flex-direction: column;
  background: #303143;
}

.md-icon-button:not(.md-primary) .md-icon {
  color: #bebebe;
}

.md-button {
  margin: 0;
}

.divider {
  height: 1px;
  background-color: #bebebe;
  margin: 5px 0;
}
</style>